import { action, on, props, reducer, union } from 'ts-action';
import React from 'react';
import colors from '@packages/core/styles/colors';

export interface IPublicationsState {
    loading: boolean;
    errors: string[];
    toast: {
        toastMessage: string;
        iconName: string;
        iconColor: keyof typeof colors;
        backgroundColor?: keyof typeof colors;
    };
    canAccessStis: boolean;
    stisFeedbackPrompt: boolean;
}

export enum publicationsActionsList {
    IS_LOADING = 'IS_LOADING',
    HAS_ERRORS = 'HAS_ERRORS',
    SET_TOAST_MESSAGE = 'SET_TOAST_MESSAGE',
    SET_CAN_ACCESS_STIS = 'SET_CAN_ACCESS_STIS',
    SET_STIS_FEEDBACK_PROMPT = 'SET_STIS_FEEDBACK_PROMPT',
}

export const publicationsActions = {
    isLoading: action(publicationsActionsList.IS_LOADING, props<{ loading: boolean }>()),
    hasErrors: action(publicationsActionsList.HAS_ERRORS, props<{ errors: string[] }>()),
    setToastMessage: action(
        publicationsActionsList.SET_TOAST_MESSAGE,
        props<{
            toast: {
                toastMessage: string;
                iconName: string;
                iconColor: keyof typeof colors;
                backgroundColor?: keyof typeof colors;
            };
        }>()
    ),
    setCanAccessStis: action(publicationsActionsList.SET_CAN_ACCESS_STIS, props<{ canAccessStis: boolean }>()),
    setStisFeedbackPrompt: action(
        publicationsActionsList.SET_STIS_FEEDBACK_PROMPT,
        props<{ stisFeedbackPrompt: boolean }>()
    ),
};

const actionsUnion = union(...Object.values(publicationsActions));
export type PublicationsActions = typeof actionsUnion.actions;

export type PublicationsActionDispatcher = React.Dispatch<PublicationsActions>;

export const initialState: IPublicationsState = {
    loading: false,
    errors: [],
    toast: { toastMessage: '', iconName: '', iconColor: 'white', backgroundColor: 'black' },
    canAccessStis: false,
    stisFeedbackPrompt: false,
};

export const publicationsReducer: React.Reducer<IPublicationsState, PublicationsActions> = reducer(
    initialState,
    on(publicationsActions.isLoading, (state, { loading }) => {
        return {
            ...state,
            loading: loading,
        };
    }),
    on(publicationsActions.hasErrors, (state, { errors }) => {
        return {
            ...state,
            errors,
        };
    }),
    on(publicationsActions.setToastMessage, (state, { toast }) => {
        return {
            ...state,
            toast: {
                ...state.toast,
                ...toast,
                backgroundColor: toast.backgroundColor ?? state.toast.backgroundColor ?? 'black',
            },
        };
    }),
    on(publicationsActions.setCanAccessStis, (state, { canAccessStis }) => {
        return {
            ...state,
            canAccessStis,
        };
    }),
    on(publicationsActions.setStisFeedbackPrompt, (state, { stisFeedbackPrompt }) => {
        return { ...state, stisFeedbackPrompt };
    })
);
